import { gql } from '@apollo/client';

export const GET_DATA_TOOLS_ITEMS = gql`
  query GetDataToolsItems($input: GetDataToolsItemsInput) {
    items: getDataToolsItems(input: $input) {
      id
      itemType
      slug
      title
      description
      category
      useCase
      dataset
      access
      moduleDependencies
      owner
      source
      refreshedAt
      status
      displayOrder
      currentVersion {
        id
        version
        publishedAt
        content
      }
    }
  }
`;
